import React, { memo } from 'react';

import styled from 'styled-components';

import { getColorStyle } from 'styles/components/getColorStyle';

/**
 * @desc 뱃지(Badge) 컴포넌트
 * @param {string} className - 추가적인 클래스명
 * @param {string} color - 뱃지 색상
 * @param {Object} badgeStyle - 추가적인 스타일
 * @returns {JSX.Element} 뱃지 컴포넌트
 */
const Badge = ({ className, color, badgeStyle, icon }) => {
  return (
    <BadgeStyle className={className} color={color} style={{ ...badgeStyle }}>
      {icon && icon}
    </BadgeStyle>
  );
};

// 뱃지 스타일링
// const BadgeStyle = styled(RxDotFilled)`
const BadgeStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  /* color prop을 통해 색상 동적 적용 */
  ${({ color }) => color && getColorStyle(color)}
`;

const PriceUseBadge = styled(Badge)`
  &.active {
    svg {
      font-size: 18px;
    }
  }
  &.other {
    svg {
      font-size: 16px;
    }
  }
`;

Badge.PriceUse = PriceUseBadge;

export default Badge;
